import { usePasswordValidation } from '../../hooks/usePasswordValidation'
import { IconCheckFilled, IconCross } from '../icons'

const renderPasswordRequirement = (isSatisfied: boolean, requirementText: string) => {
  return (
    <li className='flex items-center pl-6 pr-4 h-[22px] gap-2 select-none'>
      <div className='w-4 h-4 flex items-center justify-center'>
        {isSatisfied ? (
          <IconCheckFilled className='w-[14px] h-[14px]' />
        ) : (
          <IconCross className='w-[14px] h-[14px]' />
        )}
      </div>
      <span className='text-[12px] text-black/65 font-["Geist"] leading-[22px] select-none'>
        {requirementText}
      </span>
    </li>
  )
}

interface PasswordRequirementsProps {
  password: string
}

const PasswordRequirements = ({ password }: PasswordRequirementsProps) => {
  const { hasMinLength, hasLetter, hasNumber, hasSpecialChar } = usePasswordValidation(password)

  return (
    <div className='mt-2'>
      <ul className='flex flex-col space-y-0 gap-1'>
        {renderPasswordRequirement(hasMinLength, 'At least 12 characters')}
        {renderPasswordRequirement(hasLetter, 'Contains at least one letter')}
        {renderPasswordRequirement(hasNumber, 'At least one number')}
        {renderPasswordRequirement(hasSpecialChar, 'Contains at least one special character')}
      </ul>
    </div>
  )
}

export default PasswordRequirements
